var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDefaultAccountImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#161C23"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1523_6487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1523_6487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79167 10.4166L11 5.16656L14.2083 10.4166H7.79167ZM14.2083 16.8332C13.4792 16.8332 12.8593 16.5781 12.3487 16.0679C11.8384 15.5573 11.5833 14.9374 11.5833 14.2082C11.5833 13.4791 11.8384 12.8592 12.3487 12.3486C12.8593 11.8383 13.4792 11.5832 14.2083 11.5832C14.9375 11.5832 15.5574 11.8383 16.068 12.3486C16.5782 12.8592 16.8333 13.4791 16.8333 14.2082C16.8333 14.9374 16.5782 15.5573 16.068 16.0679C15.5574 16.5781 14.9375 16.8332 14.2083 16.8332ZM5.75 16.5416V11.8749H10.4167V16.5416H5.75Z",
    fill: "#80A9D7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultAccountImg);
export default __webpack_public_path__ + "static/media/icon-default-account-img.6047629769c6a1ac8925f71803b5bfc3.svg";
export { ForwardRef as ReactComponent };